import { TRFPDocument } from '../../../RFP/RFPDetails/types'
import { fileNameFormatter } from '../../../../helper/common'

export const formatAmendmentDocument = (data: string): TRFPDocument => ({
  file: data ? data : '',
  uuid: data ? data : '',
  file_name: data ? fileNameFormatter(data) : ''
})
